const state = {
  userInfo: null
}

const mutations = {
  setUserInfo (state, userInfo) {
    state.userInfo = userInfo
  },
  clearUserInfo (state) {
    state.userInfo = null
  }
}

const actions = {
  login ({ commit }, userInfo) {
    // 这里可以添加异步登录逻辑
    commit('setUserInfo', userInfo)
  },
  logout ({ commit }) {
    commit('clearUserInfo')
  }
}

const getters = {
  userInfo: state => state.userInfo
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
